import { createStore, useStore } from "zustand";
import { immer } from "zustand/middleware/immer";
import { createContext, useContext } from "react";
import { ImmerGet, ImmerSet } from "..";
import { DfyOrderState } from "./dfy-order-state";
import { DfyOrderService } from "./dfy-order-service";

export type Set = ImmerSet<DfyOrderState>;
export type Get = ImmerGet<DfyOrderState>;
export type DfyOrderStore = ReturnType<typeof createDfyOrderStore>;

export const createDfyOrderStore = () => {
  return createStore<DfyOrderState>()(
    immer<DfyOrderState>((set, get) => ({
      teamExternalId: "",
      orderExternalId: "",
      isInitialized: false,
      order: null,
      sourceImages: {},
      assetMedias: {},
      coupon: null,
      service: new DfyOrderService(set, get),
    })),
  );
};

export const DfyOrderStoreContext = createContext<DfyOrderStore | null>(null);

export function useDfyOrderStore<U>(selector: (state: DfyOrderState) => U) {
  const store = useContext(DfyOrderStoreContext);

  if (store === null) {
    throw new Error(
      "useDfyOrderStore must be used within a DfyOrderStoreContext provider",
    );
  }

  return useStore(store, selector);
}
